


















































import {Component, Vue} from "vue-property-decorator";
import ContactFormService, {ISubmissionForm} from "@/services/contactForm.service";
import {HashMap} from "@/services/base.service";

@Component({
    name: "ContactForm"
})
export default class ContactForm extends Vue {

    private initialized = false;
    private submission!: ISubmissionForm;
    private service!: ContactFormService;

    private errors: HashMap<string> = {};

    private submitted = false;

    private clear() {
        this.submission = {
            companyName: "",
            name: "",
            email: "",
            comments: "",
        }
        this.errors = {};
    }

    private mounted() {
        this.clear();
        this.service = new ContactFormService();
        this.initialized = true;
    }

    private async submit() {
        const response = await this.service.post(this.submission);
        if (response.success) this.submitted = true;
        else this.errors = response.error;
    }
}
